<template>
  <div class="justify-center items-center w-full mx-0 px-0" ref="googleMap">
    <tsa-map></tsa-map>
  </div>
</template>

<script>
/* eslint-disable */

import { loadWayline } from "@/views/Workspace/utils/waylineUtils.js";
import TSAMapDialog from "@/views/Workspace/components/tsa/TSAMapDialog.vue";
import TSAEventDialog from "@/views/Workspace/components/tsa/TSAEventDialog.vue";
import { Loader } from "@googlemaps/js-api-loader";
import { createApp, defineComponent, ref } from "vue";
import { storeToRefs } from "pinia";
import useStore from "@/store";
//import dockImage from "@/assets/map/dock.png";
//import droneImage from "@/assets/map/drone.png";
//import { loadWayline } from "@/views/Workspace/utils/waylineUtils.js";
const content = document.createElement("div");
import useUi2Store from "@/store/ui";


function isWithinKm(lat1, lon1, lat2, lon2, km) {
  const R = 6371; // Radio de la Tierra en kilómetros

  // Convertir grados a radianes
  const toRad = (deg) => deg * (Math.PI / 180);

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
    
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
  const distance = R * c; // Distancia en kilómetros

  return distance <= km;
}


import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { each } from "lodash";
import { formatWithOptions } from "date-fns/fp";

const vuetify = createVuetify({
  theme: {
    defaultTheme: "dark",
  },
  icons: {
    defaultSet: "mdi",
  },
  components,
  directives,
});


import { useNotify } from '@/application/services-ui/notifyService'

const notifyService = useNotify()




export default defineComponent({
  components: {
  },
  props: {
    // mapConfig: Object,
    // apiKey: String,
  },
  setup() {
    const store = useStore();
    const { telemetry } = storeToRefs(store);
    const droneSn = store.child_device_sn;
    const dockSn = store.device_sn;
    const ui2Store = useUi2Store();
    const { showFlyToPoint, flyToPointActive, realptt, customEvents } = storeToRefs(ui2Store)
    const storeRefs = storeToRefs(useStore());
    const realPttMarkers = ref({})
    const customEventMarkers = ref([])
    const {
      droneConnected,
      gatewayConnected,
      droneCoordinates,
      gatewayCoordinates,
      selectedWayline,
      markerDetections,
      autoCenter,
    } = storeRefs;
    return {
      store,
      droneConnected,
      gatewayConnected,
      droneCoordinates,
      gatewayCoordinates,
      selectedWayline,
      telemetry,
      droneSn,
      dockSn,
      showFlyToPoint,
      flyToPointActive,
      markerDetections,
      autoCenter,
      realptt,
      realPttMarkers,
      customEventMarkers,
      customEvents,
    };
  },
  computed: {
    detections() {
      if (this.markerDetections !== null && this.markerDetections !== undefined) {
        return this.markerDetections.length;
      }
      return -1;
    },
    droneHeading() {
      try {
        const heading =
          this.store.telemetry[this.store.child_device_sn]["osd_telemetry"][
            "data"
          ]["attitude_head"];
        return heading;
      } catch (e) {
        return 0;
      }
    },

    dockStatus() {
      try {
        return this.telemetry.value[dockSn]["osd_telemetry"]["data"]["mode_code"]
      } catch {
        return -1
      }
    },

    droneStatus() {
      try {
        return this.telemetry.value[droneSn]["osd_telemetry"]["data"]["mode_code"]
      } catch {
        return -1
      }
    },
    flyValidation() {
      if (this.dockStatus.value == 0) {
        return true
      } else if (this.dockStatus.value == 4 && this.droneStatus.value == 3) {
        return true
      } else {
        return false
      }
    },



  },
  watch: {
    "showMarkerFlag"(newValue, oldValue) {
      console.log ("SHOW MARKER FLAG WATCH " + newValue)
      console.log(this.eventMarkers);
      console.log(newValue == 'true')
      if (newValue == 'true') {
        console.log("IN NEW VALUE TRUE")
        this.eventMarkers.forEach((marker) => {
          marker.setMap(this.map);
          marker.map = this.map;
          marker.setVisible(true);
        });
      } else {
        console.log("IN NEW VALUE FALSE")
        this.eventMarkers.forEach((marker) => {
          marker.setMap(null);
          marker.setVisible(false);
        });
      }
      console.log(this.eventMarkers);
    },
    "markerDetections.length"(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (newValue > oldValue) {
        console.log("New detection");
        const newMarkers = this.markerDetections.slice(oldValue, newValue);
        this.addNewEventMarker(newMarkers);
      } else {
        this.addEventMarker();
      }
    },
    waylinePoints(newValue) {
      if (this.waylineLine === null) {
        this.waylineLine = new this.google.maps.Polyline({
          path: newValue,
          geodesic: true,
          strokeColor: "#FFFFFF",
          strokeOpacity: 1.0,
          strokeWeight: 2,
          map: this.map,
        });
      } else {
        this.waylineLine.setPath(newValue);
      }
    },
    droneHeading(newValue) {
      this.droneIcon.rotation = newValue;
      this.store.droneMarker.setIcon(this.droneIcon);
    },
    gatewayCoordinates(newValue, oldValue) {
      if (this.map !== null) {
        if (oldValue.lat == 0 && oldValue.lng == 0) {
          this.map.setCenter(newValue);
          this.map.setZoom(16);
        }
      }
    },
    droneCoordinates(newValue, oldValue) {
      if (this.map !== null) {
        if (oldValue.lat == 0 && oldValue.lng == 0) {
          this.map.setCenter(newValue);
          this.map.setZoom(16);
        }
        this.store.droneMarker.setPosition(newValue);
        if (this.autoCenter) {
          const c = {
            "lat": newValue.lat,
            "lng": newValue.lng - 0.0075,
          }
          this.map.setCenter(c);
        }
      }
    },
    gatewayConnected(newValue) {
      if (this.map !== null) {
        this.store.gatewayMarker.setVisible(newValue == 1 ? true : false);
        this.store.gatewayMarker.setMap(newValue == 1 ? this.map : null);
      }
    },
    droneConnected(newValue) {
      if (this.map !== null) {
        this.store.droneMarker.setVisible(newValue == 1 ? true : false);
        this.store.droneMarker.setMap(newValue == 1 ? this.map : null);
      }
    },
    async selectedWayline(newValue) {
      this.removeWayline();
      this.waylinePoints = [];
      if (newValue !== null) {
        const points = await loadWayline(newValue);
        this.waylinePoints = points;
        this.initWayline(points);
        this.showWayline();
        const center = this.getWaylineCenter(points);
        this.map.setCenter(center);
        this.map.setZoom(16);
      }
    },
  },
  data() {
    return {
      google: null,
      map: null,
      waylineMarkers: [],
      waylineLine: null,
      waylinePoints: [],
      clickMarker: null,
      eventMarkers: [],
      eventMarkerIcon: null,
      showMarkerFlag: ref(null),
    };
  },
  async mounted() {

    const tid = setInterval(() => {
      if (this.flyValidation.value == false) {
        this.showFlyToPoint = 1
      } else if (this.flyToPointActive == true) {
        this.showFlyToPoint = 2
      } else {
        this.showFlyToPoint = 3
      }
    }, 1000
    )
    const tidFrame = setInterval(() => {
      var showFrame = false;
      const lshowFrame = localStorage.getItem("showFrame")
      console.log("SHOW FRAME TID: " + lshowFrame)
      if (lshowFrame === null || lshowFrame === undefined) {
        showFrame = false
      } else {
        showFrame = lshowFrame
      }
      
      this.showMarkerFlag = showFrame
    }, 1000
    )
    const tidRealptt = setInterval(() => {
      const keys = Object.keys(this.realptt); 
      for (var i = 0; i < keys.length; i++) {
        const selected = this.realptt[keys[i]]
        const sn = selected["sn"]
        const latitude = parseFloat(selected["latitude"])
        const longitude = parseFloat(selected["longitude"])
        const name = selected["nickname"].split("_")[0]
        if (sn in this.realPttMarkers) {
          this.realPttMarkers[sn].setPosition({lat: latitude, lng: longitude})
        } else {
          this.realPttMarkers[sn] = new this.google.maps.Marker({
            position: {
              lat: latitude,
              lng: longitude,
            },
            map: this.map,
            visible: true,
            title: name,
            icon: this.gpsTrakIcon,
            label: {
              text: name,
              color: "#000000",
              fontWeight: "bold",
              fontSize: "12px",
            }
          });
        }
        console.log(this.realPttMarkers)
      }
    }, 1000)

    const customEventMarkerTid = setInterval(() => {
      console.log("Custom Event Marker")
      console.log(this.customEvents)
      for (let i = 0; i < this.customEvents.length; i++) {
        const dmarker = this.customEvents[i]
        console.log(dmarker)
        let openDialog = false;
        let customMarker = new this.google.maps.Marker({
          position: {
            lat: dmarker["latitude"],
            lng: dmarker["longitude"],
          },
          map: this.map,
          visible: true,
          title: dmarker["nickname"],
          label: {
              text: dmarker["nickname"],
              color: "#FFFFFF",
              fontWeight: "bold",
              fontSize: "12px",
              color
            }
        });
        const content = document.createElement("div");
          var app = createApp(TSAEventDialog, { event: dmarker })
          app.use(vuetify);
          app.mount(content)



          const infowindow2 = new this.google.maps.InfoWindow({
            content: content,            
          })
          //infowindow.setHeaderContent("<h1 style='background-color: red'>hi hi hi</h1>")
          infowindow2.setHeaderDisabled = true;
          infowindow2.addListener("closeclick", () => {
            customMarker.setMap(null)
            customMarker.setVisible(false);
            customMarker = null
            app.unmount()
          })


          customMarker.addListener("click", () => {
            openDialog = !openDialog;
            if (openDialog) {

              infowindow2.open({
                anchor: customMarker,
                map: this.map,
              })
            } else {
              infowindow2.close();
            }
          })



      }
      this.customEvents = []
      
    }, 1000)

    this.droneConnected = false;
    this.gatewayConnected = false;
    this.droneCoordinates = { lat: 0, lng: 0 };
    this.gatewayCoordinates = { lat: 0, lng: 0 };
    const googleMapApi = new Loader({
      apiKey: "AIzaSyA18csPg7BRihV1O9iU9qBjMKFtuRti5eY",
      version: "weekly",
      libraries: ["places"],
    });
    const mapOptions = {
      center: {
        lat: -33.4489,
        lng: -70.6693,
      },
      zoom: 10,
      streetViewControl: false,
      tilt: 0,
      rotateControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
      zoomControl: false,
    };
    this.mapOptions = mapOptions;
    googleMapApi
      .load()
      .then((google) => {
        this.google = google;
        this.store.google = google;
        this.createMapIcons();
        this.initializeMap();
        this.map.addListener("rightclick", (e) => {
          console.log("Right click", e);
        });
      })
      .catch((e) => {
        console.error("Error loading Google Maps API", e);
      });
  },

  methods: {
    isWithinKm,
    addNewEventMarker(newMarkers) {
      if (this.map !== null && this.map !== undefined) {
        for (let i = 0; i < newMarkers.length; i++) {
          const marker = new this.google.maps.Marker({
            position: {
              lat: newMarkers[i].drone_latitude,
              lng: newMarkers[i].drone_longitude,
            },
            map: this.showMarkerFlag === 'true' ? this.map : null,
            visible: this.showMarkerFlag === 'true' ? true : false,
            title: "Detection",
            icon: this.eventMarkerIcon,
          });  
          this.eventMarkers.push(marker);
          var data =
            '<IMG width=100% height=100%   SRC="data:image/jpg;base64,' +
            newMarkers[i]["frame"]["data"] +
            '">';
          var infowindow = new this.google.maps.InfoWindow({
            content: data,
            
          });
          this.google.maps.event.addListener(marker, "click", function () {
            const localStore = useStore();
            localStore.autoCenter = false;
            infowindow.open(this.map, marker);
          });
        }
      }
    },
    removeEventMarker() {
      this.clickMarker
    },
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapOptions);
      this.store.map = this.map;
      this.map.setMapTypeId("satellite");
      const gatewayMarker = new this.google.maps.Marker({
        position: this.gatewayCoordinates,
        map: this.gatewayConnected ? this.map : null,
        title: "Gateway",
        icon: this.gatewayIcon,
      });
      const droneMarker = new this.google.maps.Marker({
        position: this.droneCoordinates,
        map: this.droneConnected ? this.map : null,
        title: "Drone",
        icon: this.droneIcon,
      });
      this.store.gatewayMarker = gatewayMarker;
      this.store.droneMarker = droneMarker;
      
      this.map.addListener('click', (e) => {
        if (this.flyToPointActive == 1) {
        const dock_lat = this.store.gatewayMarker.position.lat();
        const dock_lng = this.store.gatewayMarker.position.lng();
        const p_lat = e.latLng.lat();
        const p_lng = e.latLng.lng();
        const isInRange = this.isWithinKm(dock_lat, dock_lng, p_lat, p_lng, 5);
        if (isInRange == false) {
          notifyService.showAlert('POINT_TOO_AWAY')
          return
        }
        console.warn(dock_lat, dock_lng, p_lat, p_lng)  
        
        if (this.clickMarker === null) {
          var app = createApp(TSAMapDialog, { event: e })
          app.use(vuetify);
          app.mount(content)



          const infowindow = new this.google.maps.InfoWindow({
            content: content,            
          })
          //infowindow.setHeaderContent("<h1 style='background-color: red'>hi hi hi</h1>")
          infowindow.setHeaderDisabled = true;
          infowindow.addListener("closeclick", () => {
            this.clickMarker.setMap(null)
            this.clickMarker.setVisible(false);
            this.clickMarker = null
            app.unmount()
          })


          this.clickMarker = new this.google.maps.Marker({
            position: e.latLng,
            title: 'Event',
            map: this.map,
            icon: this.gotoIcon,

          })
          this.clickMarker.addListener("click", () => {
            if (infowindow.getMap() === null) {
              infowindow.open({
                anchor: this.clickMarker,
                map: this.map,
              })
            } else {
              infowindow.close()
            }
          })

        }
      }
        })
    },
    createMapIcons() {
      /*
      this.gatewayIcon = {
        path: "M12 20C7.6 20 4 16.4 4 12S7.6 4 12 4 20 7.6 20 12 16.4 20 12 20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M11 14H13V17H16V12H18L12 7L6 12H8V17H11V14",
        anchor: new this.google.maps.Point(12, 12),
        fillColor: "#2196F3",
        fillOpacity: 0.75,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 4,
      };
      */
      this.gatewayIcon = {
        url: "https://gitlab.mindlabs.cl/public-data/fronticons/-/raw/main/dock.svg", 
        anchor: new this.google.maps.Point(36, 36),
        fillColor: "#2196F3",
        fillOpacity: 0.75,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 1,
        scaledSize : new this.google.maps.Size(72, 72)
      };
      this.gotoIcon = {
        url: "https://gitlab.mindlabs.cl/public-data/fronticons/-/raw/main/icon_goto.png", 
        anchor: new this.google.maps.Point(36, 36),
        fillColor: "#2196F3",
        fillOpacity: 0.75,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 1,
        scaledSize : new this.google.maps.Size(56, 56)
      };
      this.droneIcon = {
        path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, //droneImage,
        anchor: new this.google.maps.Point(0, 2.5),
        fillColor: "#76FF03",
        fillOpacity: 0.75,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 10,
      };
      this.waylineIcon = {
        path: this.google.maps.SymbolPath.CIRCLE, //droneImage,
        anchor: new this.google.maps.Point(0, 0),
        fillColor: "#FF0000",
        fillOpacity: 0.75,
        strokeWeight: 0,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 10,
      };
      /*this.eventMarkerIcon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        anchor: new this.google.maps.Point(0, 2.5),
        fillColor: "#FB8C00",
        fillOpacity: 0.8,
        strokeWeight: 2,
        strokeColor: "#000000",
        rotation: 0,
        scale: 10,
      };*/
      this.eventMarkerIcon = {
        url: "https://gitlab.mindlabs.cl/public-data/fronticons/-/raw/main/icon_alerta_deteccion.png", 
        anchor: new this.google.maps.Point(18, 18),
        fillColor: "#2196F3",
        fillOpacity: 0.75,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 1,
        scaledSize : new this.google.maps.Size(36, 36)
      };
      this.gpsTrakIcon = {
        url: "https://gitlab.mindlabs.cl/public-data/fronticons/-/raw/main/icon_traking.png", 
        //url: "https://gitlab.mindlabs.cl/public-data/fronticons/-/raw/main/police-radio.png", 

        anchor: new this.google.maps.Point(36, 36),
        fillColor: "#2196F3",
        fillOpacity: 0.8,
        strokeWeight: 2,
        strokeColor: "#00000000",
        rotation: 0,
        scale: 1,
        scaledSize : new this.google.maps.Size(72, 72),
        
      };
    },
    initWayline(points) {
      this.points = points;
      let markers = [];
      let counter = 0;
      let waylineIcon = null;
      points.forEach((point) => {
        if (counter == 0) {
          waylineIcon = JSON.parse(JSON.stringify(this.waylineIcon));
          waylineIcon.fillColor = "#00FF00";
        } else if (counter == points.length - 1) {
          waylineIcon = JSON.parse(JSON.stringify(this.waylineIcon));
          waylineIcon.fillColor = "#FF0000";
        } else {
          waylineIcon = JSON.parse(JSON.stringify(this.waylineIcon));
          waylineIcon.fillColor = "#0000FF";
        }
        const marker = new this.google.maps.Marker({
          position: point,
          map: this.map,
          title: "W_" + counter++,
          icon: waylineIcon,
        });
        markers.push(marker);
      });
      this.waylineMarkers = markers;
    },
    showWayline() {
      this.waylineMarkers.forEach((marker) => {
        marker.setMap(this.map);
        marker.setVisible(true);
      });
    },
    hideWayline() {

      this.waylineMarkers.forEach((marker) => {
        marker.setMap(null);
        marker.setVisible(false);
      });
    },
    removeWayline() {
      this.waylineMarkers.forEach((marker) => {
        marker.setMap(null);
        marker.setVisible(false);
      });
      this.waylineMarkers = [];
    },
    getWaylineCenter(points) {
      let lat = 0;
      let lng = 0;
      points.forEach((point) => {
        lat += point.lat;
        lng += point.lng;
      });
      return { lat: lat / points.length, lng: lng / points.length };
    }
  },
});
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.iconclass {
  padding: 5px;
  border-radius: 5px;
  font-family: sans-serif;
}

</style>
